import { logAndylitics, log, logAPI } from "./andyliticsApi";
import * as tools from "../helpers/Tools";

const instaDocBFFBaseUrl = typeof window !== 'undefined' ? window.serverData.data.instaDocBFFBaseUrl : ''; // window is undefined during pre-render
const instaDocBFFXFunctionsKey = typeof window !== 'undefined' ? window.serverData.data.instaDocBFFXFunctionsKey : '';
const videoVistTypeInternalId = typeof window !== 'undefined' ? window.serverData.data.videoVistTypeInternalId : '';

export const negotiateSignalR = (token, providerEpicId, startDate, endDate) => {
    const url = tools.buildUrl(instaDocBFFBaseUrl, '/api/negotiate');

    //var body = {
    //    startDate: startDate,
    //    endDate: endDate,
    //    providers: [
    //        {
    //            id: providerEpicId,
    //            idType: "External"

    //        }]
    //};

    const params = {
        method: "POST",
        //body: JSON.stringify(body),
        headers: {
            "Accept": "application/json",
            "Content-type": "application/json",
            "x-functions-key": instaDocBFFXFunctionsKey,
            //"Authorization": "bearer " + token
        },
        mode: 'no-cors'
    };
    var start = new Date();

    return fetch(url, params).then(response => {
        logAPI("Api.InstaDocBFF.SigRNegotiate.Post", start, url);
        if (response.status >= 200 && response.status < 300) {
            return Promise.resolve(response.json());
        } else {
            return Promise.reject(response);
        }
    }).catch(err => {
        logAPI("Api.InstaDocBFF.SigRNegotiate.Post.Failure", start, url, err);
        return Promise.reject(err);
    });

};

export const syncRooms = (token, providerEpicId, startDate, endDate) => {
    const url = tools.buildUrl(instaDocBFFBaseUrl, '/api/v1/rooms/sync');

    var body = {
        startDate: startDate,
        endDate: endDate,
        providers: [
            {
                id: providerEpicId,
                idType: "External"

            }]
    };

    const params = {
        method: "POST",
        body: JSON.stringify(body),
        headers: {
            "Accept": "application/json",
            "Content-type": "application/json",
            "x-functions-key": instaDocBFFXFunctionsKey,
            "Authorization": "bearer " + token
        },
        mode: 'no-cors'
    };
    var start = new Date();

    return fetch(url, params).then(response => {
        logAPI("Api.InstaDocBFF.Sync.Post", start, url, body);
        if (response.status >= 200 && response.status < 300) {
            return Promise.resolve(response);
        } else {
            return Promise.reject(response);
        }
    }).catch(err => {
        logAPI("Api.InstaDocBFF.Sync.Post.Failure", start, url, err);
        return Promise.reject(err);
    });

};

export const getEmployee = (token, lanId) => {
    const url = tools.buildUrl(instaDocBFFBaseUrl, '/api/v1/employee?id=' + encodeURIComponent(lanId));

    const params = {
        method: "GET",
        //body: JSON.stringify(body),
        headers: {
            "Accept": "application/json",
            "Content-type": "application/json",
            "x-functions-key": instaDocBFFXFunctionsKey,
            "Authorization": "bearer " + token
        },
        mode: 'no-cors'
    };
    var start = new Date();

    return fetch(url, params).then(response => {
        logAPI("Api.InstaDocBFF.getEmployee.Post", start, url);
        if (response.status >= 200 && response.status < 300) {
            return Promise.resolve(response.json());
        } else {
            return Promise.reject(response);
        }
    }).catch(err => {
        logAPI("Api.InstaDocBFF.getEmployee.Post.Failure", start, url, err);
        return Promise.reject(err);
    });

};

export const getProviderInfo = (token, lanId) => {
    const url = tools.buildUrl(instaDocBFFBaseUrl, `/api/v2/providerInfo?ID=${encodeURIComponent(lanId)}&IDType=NetworkID`);

    const params = {
        method: "GET",
        headers: {
            "Accept": "application/json",
            "Content-type": "application/json",
            "x-functions-key": instaDocBFFXFunctionsKey,
            "Authorization": "bearer " + token
        },
        mode: 'no-cors'
    };
    var start = new Date();

    return fetch(url, params).then(response => {
        logAPI("Api.InstaDocBFF.getProviderInfo.Get", start, url);
        if (response.status >= 200 && response.status < 300) {
            return Promise.resolve(response.json());
        } else {
            return Promise.reject(response);
        }
    }).catch(err => {
        logAPI("Api.InstaDocBFF.getProviderInfo.Get.Failure", start, url, err);
        return Promise.reject(err);
    });
};

export const subscribeForSync = (token, departmentId) => {
    const url = tools.buildUrl(instaDocBFFBaseUrl, `/api/v1/sync/subscribe?ID=${encodeURIComponent(departmentId)}&IDType=DepartmentID`);

    const params = {
        method: "GET",
        headers: {
            "Accept": "application/json",
            "Content-type": "application/json",
            "x-functions-key": instaDocBFFXFunctionsKey,
            "Authorization": "bearer " + token
        },
        mode: 'no-cors'
    };
    var start = new Date();

    return fetch(url, params).then(response => {
        logAPI("Api.InstaDocBFF.subscribeForSync.Get", start, url, { departmentId });
        if (response.status >= 200 && response.status < 300) {
            return Promise.resolve(response);//.json());
        } else {
            return Promise.reject(response);
        }
    }).catch(err => {
        logAPI("Api.InstaDocBFF.subscribeForSync.Get.Failure", start, url, { departmentId }, err);
        return Promise.reject(err);
    });
};

export const getProviders = (token, departmentId, startDate, endDate) => {
    const url = tools.buildUrl(instaDocBFFBaseUrl, '/api/v1/providers');
    const params = {
        method: "POST",
        body: JSON.stringify({ departmentId, startDate, endDate }),
        headers: {
            "Accept": "application/json",
            "Content-type": "application/json",
            "x-functions-key": instaDocBFFXFunctionsKey,
            "Authorization": "bearer " + token
        },
        mode: 'no-cors'
    };
    var start = new Date();

    return fetch(url, params).then(response => {
        logAPI("Api.InstaDocBFF.getProviders.Get", start, url);
        if (response.status >= 200 && response.status < 300) {
            return Promise.resolve(response.json());
        } else {
            return Promise.reject(response);
        }
    }).catch(err => {
        logAPI("Api.InstaDocBFF.getProviders.Get.Failure", start, url, err);
        return Promise.reject(err);
    });
};

export const getProvidersV2 = (token, deptInternalId) => {
    const url = tools.buildUrl(instaDocBFFBaseUrl, '/api/v2/providers');
    const params = {
        method: "POST",
        body: JSON.stringify({ deptInternalId }),
        headers: {
            "Accept": "application/json",
            "Content-type": "application/json",
            "x-functions-key": instaDocBFFXFunctionsKey,
            "Authorization": "bearer " + token
        },
        mode: 'no-cors'
    };
    var start = new Date();

    return fetch(url, params).then(response => {
        logAPI("Api.InstaDocBFF.getProviders.Get", start, url);
        if (response.status >= 200 && response.status < 300) {
            return Promise.resolve(response.json());
        } else {
            return Promise.reject(response);
        }
    }).catch(err => {
        logAPI("Api.InstaDocBFF.getProviders.Get.Failure", start, url, err);
        return Promise.reject(err);
    });
};

export const exchangeToken = (token) => {
    const url = tools.buildUrl(instaDocBFFBaseUrl, '/api/exchange');
    var body = {
        token: token
    };

    const params = {
        method: "POST",
        body: JSON.stringify(body),
        headers: {
            "Accept": "application/json",
            "Content-type": "application/json",
            "x-functions-key": instaDocBFFXFunctionsKey
            //"Authorization": "bearer " + token
        },
        mode: 'no-cors'
    };
    var start = new Date();

    return fetch(url, params).then(response => {
        logAPI("Api.InstaDocBFF.ExchangeToken.Post", start, url);
        if (response.status >= 200 && response.status < 300) {
            return Promise.resolve(response.json());
        } else {
            return Promise.reject(response);
        }
    }).catch(err => {
        logAPI("Api.InstaDocBFF.ExchangeToken.Post.Failure", start, url, err);
        return Promise.reject(err);
    });

};

export const getProviderAppointments = (token, providerEpicIds, departmentEpicIDs, startDate, endDate, includeHistory = false) => {
    const url = tools.buildUrl(instaDocBFFBaseUrl, '/api/v1/rooms');
    const body = { startDate, endDate, includeHistory };
    if (providerEpicIds && providerEpicIds.length > 0) {
        body.providers = [];
        for (let i = 0; i < providerEpicIds.length; i++) {
            body.providers.push({ ...providerEpicIds[i], visitTypeInternalId: videoVistTypeInternalId });
        }
    }
    else if (departmentEpicIDs && departmentEpicIDs.length > 0) {
        body.departments = [];
        for (let i = 0; i < departmentEpicIDs.length; i++) {
            body.departments.push({ departmentInternalID: departmentEpicIDs[i], visitTypeInternalId: videoVistTypeInternalId });
        }
    }

    // we don't use an authorization header because it is added for us by adalFetch (Healthsource tokens must be manually passed on the model)
    const payload = JSON.stringify(body);
    const params = {
        method: "POST",
        body: payload,
        headers: {
            "Accept": "application/json",
            "Content-type": "application/json",
            "x-functions-key": instaDocBFFXFunctionsKey,
            "Authorization": "bearer " + token
        },
        mode: 'no-cors'
    };
    const start = new Date();

    return fetch(url, params).then(response => {
        logAPI("Api.InstaDocBFF.ProviderAppointments.Get", start, url, payload);
        if (response.status >= 200 && response.status < 300) {
            return Promise.resolve(response.json());
        } else {
            return Promise.reject(response);
        }
    }).catch(err => {
        logAPI("Api.InstaDocBFF.ProviderAppointments.Get.Failure", start, url, err);
        return Promise.reject(err);
    });
};


export const getSameDayCareAppointments = (token, providerEpicId, departmentEpicIDs, startDate, endDate) => {
    //debugger;
    const url = tools.buildUrl(instaDocBFFBaseUrl, '/api/appointments?depid=1034002261&resid=153284');
    var body = {
        StartDate: startDate,
        EndDate: endDate,
        Providers: []
    };
    //if (departmentEpicIDs && departmentEpicIDs.length > 0) {
    //    for (var i = 0; i < departmentEpicIDs.length; i++) {
    //        if (providerEpicId) {
    //            body.Providers.push({
    //                departmentInternalID: departmentEpicIDs[i],
    //                providerExternalId: providerEpicId
    //            });
    //        }
    //        else {
    //            body.Providers.push({
    //                departmentInternalID: departmentEpicIDs[i]
    //            });
    //        }
    //    }
    //}
    //else {
    //    body.Providers.push({
    //        providerExternalId: providerEpicId
    //    });
    //}
    // we don't use an authorization header because it is added for us by adalFetch (Healthsource tokens must be manually passed on the model)
    const params = {
        method: "GET",
        headers: {
            "Accept": "application/json",
            "Content-type": "application/json",
            "x-functions-key": instaDocBFFXFunctionsKey,
            "Authorization": "bearer " + token
        },
        mode: 'no-cors'
    };
    var start = new Date();

    return fetch(url, params).then(response => {
        logAPI("Api.InstaDocBFF.SameDayCareAppointments.Get", start, url);
        if (response.status >= 200 && response.status < 300) {
            return Promise.resolve(response.json());
        } else {
            return Promise.reject(response);
        }
    }).catch(err => {
        logAPI("Api.InstaDocBFF.SameDayCareAppointments.Get.Failure", start, url, err);
        return Promise.reject(err);
    });
};

export const setRoomStatus = (token, roomId, status) => {
    const url = tools.buildUrl(instaDocBFFBaseUrl, '/api/v1/rooms/status');

    const body = {
        roomId: roomId,
        status: status
    };

    const params = {
        method: "POST",
        headers: {
            "Accept": "application/json",
            "Content-type": "application/json",
            "x-functions-key": instaDocBFFXFunctionsKey,
            "Authorization": "bearer " + token
        },
        body: JSON.stringify(body),
        mode: 'no-cors'
    };
    var start = new Date();

    return fetch(url, params)
        .then(resp => {
            return resp.json();
        })
        .catch(err => {
            return Promise.reject(err);
        });
};

export const getRoomDetails = (token, roomId) => {
    const url = tools.buildUrl(instaDocBFFBaseUrl, `/api/v1/room/${roomId}`);
    const params = {
        method: "GET",
        headers: {
            "Accept": "application/json",
            "Content-type": "application/json",
            "x-functions-key": instaDocBFFXFunctionsKey,
            "Authorization": "bearer " + token
        },
        mode: 'no-cors'
    };
    var start = new Date();

    return fetch(url, params).then(response => {
        logAPI("Api.InstaDocBFF.RoomDetails.Get", start, url);
        if (response.status >= 200 && response.status < 300) {
            return Promise.resolve(response.json());
        } else {
            return Promise.reject(response);
        }
    }).catch(err => {
        logAPI("Api.InstaDocBFF.RoomDetails.Get.Failure", start, url, err);
        return Promise.reject(err);
    });
};

export const settings = (token, lanId, apiMethod, payload) => {
    const method = apiMethod ? apiMethod.toUpperCase() : 'GET';
    let url = tools.buildUrl(instaDocBFFBaseUrl, `/api/v1/settings${method === 'POST' ? '' : '?lanid=' + lanId}`);
    const params = {
        method,
        headers: {
            "Accept": "application/json",
            "Content-type": "application/json",
            "x-functions-key": instaDocBFFXFunctionsKey,
            "Authorization": "bearer " + token
        },
        body: apiMethod !== 'GET' && payload ? JSON.stringify(payload) : null,
        mode: 'no-cors'
    };
    var start = new Date();

    return fetch(url, params).then(response => {
        logAPI('Api.InstaDocBFF.Settings.' + method, start, url);
        if (response.status === 200) {
            return method === 'PATCH' ? Promise.resolve(response) : Promise.resolve(response.json());
        } else if (response.status === 204) {
            url = tools.buildUrl(instaDocBFFBaseUrl, '/api/v1/settings');
            params.method = 'POST';
            params.body = JSON.stringify({ epicExternalId: payload.epicExternalId, lanId, smsNumber: '', sendSms: false, smsNumberPopupCount: 0 });
            return fetch(url, params).then(response => {
                if (response.status === 200 || response.status === 201) {
                    return Promise.resolve(response.json());
                }
                else {
                    return Promise.reject(response.json());
                }
            });
        }
        else {
            return Promise.reject(response.json());
        }
    }).catch(err => {
        const error = { status: err && err.status, statusText: err && err.statusText };
        logAPI('Api.InstaDocBFF.Settings.' + method + '.Failure', start, url, error);
        return Promise.reject(error);
    });
};